import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ChevronRight } from 'lucide-react';
import PreviouslyValuedProperties from '../../components/dashboard/PreviouslyValuedProperties';

export default function Valuations() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Breadcrumb header */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-2 text-sm">
            <Link
              to="/dashboard"
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              Dashboard
            </Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="text-gray-500">Valuations</span>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-2">
          <FileText className="w-6 h-6 text-blue-600" />
          <h1 className="text-2xl font-bold text-gray-900">Property Valuations</h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          View, search, and manage all your property valuations. Click any property to see its full analysis.
        </p>

        <PreviouslyValuedProperties showAll={true} />
      </div>
    </div>
  );
}
